import MobileComponent from "./MobileComponent";

const useDefaultMobileProps = (columns) => {
  const mobileColumns = ["id", "displayName", "uuid"];
  for (let column of columns) {
    mobileColumns.push(column.propertyName);
  }

  return { getComponent:()=> MobileComponent, mobileColumns };
};
export default useDefaultMobileProps;
